import * as React from 'react';

export function useStateWithHistory<T>(
  initialValue: T | (() => T),
  historyLength: number,
): [T, React.Dispatch<React.SetStateAction<T>>, T[]] {
  const stateHistoryRef = React.useRef<T[]>([]);
  const [state, setState] = React.useState<T>(initialValue);

  React.useEffect(() => {
    stateHistoryRef.current = [state, ...stateHistoryRef.current].slice(0, historyLength);
  }, [state, historyLength]);

  return [state, setState, stateHistoryRef.current];
}
